import React, { FC, useMemo } from 'react';
import {
  Button,
  Box,
  TextField,
  InputAdornment,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/blogs-module/BlogsViewV2/components/SearchAndSortSection/SearchAndSortSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  RiSortAsc,
  RiSortDesc,
  RiSearchLine,
  RiCloseLine,
} from 'react-icons/ri';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import { BLOGS_SORT } from 'lib/utils/CONSTANTS';
import { Typography700 } from 'views/rebranded-module/common/components';
import { SearchAndSortProps } from 'views/rebranded-module/blogs-module/BlogsViewV2/components/SearchAndSortSection/SearchAndSortSection.interface';


const SearchAndSortSection: FC<SearchAndSortProps> = (props) => {
  const {
    searchQuery,
    handleSearchEntryEnter,
    setSearchQuery,
    blogsFilteredListCount,
    sortDirection,
    handleSortDirectionChange,
    query,
  } = props;
  const content = useContent('BlogsPage');

  const isAscending = useMemo(() => {
    return sortDirection === BLOGS_SORT.ascending;
  }, [sortDirection]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    //if the user clears the input, go back to main listing
    if (value.trim() === '') {
      handleSearchEntryEnter('');
    }
  };
  
  const handleCloseBtnClick = () => {
    setSearchQuery('');
    handleSearchEntryEnter('');
  };

  const checkEnter = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const content = e.target.value;
      handleSearchEntryEnter(content);
    }
  };
  return (
    <StyledBox>
      <Box className="BLSSearchAndResultContiner">
        <TextField
          placeholder={content.searchPlaceholder}
          value={searchQuery}
          onChange={handleInputChange}
          onKeyDown={checkEnter}
          variant="outlined"
          className="HSSearchInput"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <RiSearchLine className="SSSInputIcon" />
              </InputAdornment>
            ),
            endAdornment: searchQuery ? (
              <InputAdornment position="end">
                <RiCloseLine
                  className="SSSInputIcon SSSCloseIcon"
                  onClick={handleCloseBtnClick}
                />
              </InputAdornment>
            ) : null,
          }}
        />
        {(query && blogsFilteredListCount !== null) && (
          <Typography700 component="span" variant="body2" className="BLSResults">
            {interpolateString(content.resultsFoundText, {
              value: blogsFilteredListCount,
            })}
          </Typography700>
        )}
      </Box>
      <Button
        startIcon={
          isAscending ? (
            <RiSortDesc className="SSSSortIcon" />
          ) : (
            <RiSortAsc className="SSSSortIcon" />
          )
        }
        color="secondary"
        className="BLSSortBtn"
        onClick={() => {
          handleSortDirectionChange(
            isAscending ? BLOGS_SORT.descending : BLOGS_SORT.ascending,
          );
        }}>
        {isAscending ? content.sortByOldest : content.sortByNewest}
      </Button>
    </StyledBox>
  );
};

export { SearchAndSortSection };
